/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "theme-ui";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ModalWithPortal from "./ModalWithPortal";
import { useSnapshot } from "valtio";
import store from "../../appStore";
import ImpressumIcon from "/assets/images/impressumIcon.png";

const Impressum = (props) => {
  const snap = useSnapshot(store);
  const [isOpenPortal, setIsOpenPortal] = useState(false);

  const handleOpenPortal = () => {
    setIsOpenPortal(true);
  };

  return (
    <>
      <div
        sx={{
          position: "absolute",
          // right:
          //   snap.sideBarVisible && !snap.sideBarToggle
          //     ? ["30vw", "30vw", "28.5vw"]
          //     : "1.5vw",
          right: "auto",
          // transition: "0.5s",
          left: "2vw",
          bottom: "1.5vw",
          width: "max-content",
          textAlign: "center",
          cursor: "pointer",
          textTransform: "uppercase",
          fontWeight: "normal",
          fontSize: "0.75vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
        onClick={handleOpenPortal}
      >
        <img style={{ width: "1.1vw" }} src={ImpressumIcon} alt="Impressum" />
      </div>

      <ModalWithPortal isOpenPortal={isOpenPortal} setIsOpenPortal={setIsOpenPortal}>
        <div
          style={{
            background: "#fff",
            width: "50vw",
            padding: "3vw",
            zIndex: "99999999999999999999999999999999",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "4vh",
            }}
          >
            <h2
              style={{
                color: "black",
                fontWeight: "500",
                fontSize: "2vw",
                margin: 0,
              }}
            >
              Legals
            </h2>

            <CloseIcon
              style={{
                color: "#37a46e",
                cursor: "pointer",
                position: "relative",
                top: "-2vw",
                right: "-1.5vw",
                fontSize: "1.5vw",
              }}
              onClick={() => setIsOpenPortal(false)}
            />
          </div>
          <Link linkTitle="Imprint" linkText="Impressum" linkUrl="https://www.efd-induction.com/de-de/about/impressum" />

          <Link
            linkTitle="Privacy Policy"
            linkText="Datenschutzerklärung"
            linkUrl="https://www.efd-induction.com/de-de/about/data-privacy-protection"
          />

          {import.meta.env.MODE === "electron" && window.updater?.appVersion && (
            <p style={{ color: "#191b23", fontSize: "0.75vw", marginTop: "2vh" }}>Version {window.updater.appVersion}</p>
          )}
        </div>
      </ModalWithPortal>
    </>
  );
};

export default Impressum;

const Link = ({ linkTitle, linkText, linkUrl }) => {
  return (
    <>
      <p
        style={{
          color: "#191b23",
          fontWeight: "400",
          fontSize: "1.2vw",
          marginBottom: "0.75vh",
        }}
      >
        {linkTitle}
      </p>
      <a
        style={{
          color: "#37a46e",
          fontSize: "0.85vw",
        }}
        href={linkUrl}
        target="_blank"
        rel="noreferrer"
      >
        {linkText}
      </a>
    </>
  );
};
